<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<platformList></platformList>
		</div>
		<div class="add" v-if="type==='see'">
		</div>
	</div>
</template>
<script>
	import platformList from "../comp/platform_list.vue"
	export default {
		components:{platformList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.platformParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
